const firebaseConfig = {
    apiKey: "AIzaSyAOlZrKcZra56X8iauJN7KzL0YJxT7YisA",
    authDomain: "tourist-site-d8c07.firebaseapp.com",
    projectId: "tourist-site-d8c07",
    storageBucket: "tourist-site-d8c07.appspot.com",
    messagingSenderId: "780334810914",
    appId: "1:780334810914:web:f6170bda71c0f27366077b"
};
export default firebaseConfig;